// src/App.js
import React from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Home from './components/Home';
import About from './components/About';
import './App.css';
import Footer from './components/Footer';
import TermsAndConditions from './components/TermsConditions';
import SignupPage from './components/SignUp';
import LoginPage from './components/Login';
import UserProfile from './components/UserProfile';
import RunPage from './components/RunPage';
import SignUpSuccess from './components/SuccessSignUp';
import { UserProvider } from './Contexts/UserContext';
import RunShowPage from './components/RunShowPage';
import Navigation from './components/Navigation';
import Logout from './components/Logout';
import EditUserProfile from './components/EditUserProfile';
import PrivacyPolicy from './components/PrivacyPolicy';
import PricingCards from './components/Pricing';
import OurServicesPage from './components/Services';
import ContactUsPage from './components/ContactUs';
import LoginRequired from './components/LoginRequired';

function App() {
  return (
    <Router>
      <UserProvider>
        <div className="App">
          <Navigation />
          <Container className="mt-4">
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/signup_success" element={<SignUpSuccess />} />
              <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/pricing" element={<PricingCards />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/login_required" element={<LoginRequired />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/services" element={<OurServicesPage />} />
              <Route path="/contact_us" element={<ContactUsPage />} />
              <Route path="/user_profile" element={<UserProfile />} />
              <Route path="/user_profile/edit" element={<EditUserProfile />} />
              <Route path="/run_qpadm" element={<RunPage />} />
              <Route path="/privacy_policy" element={<PrivacyPolicy />} />
              <Route path="/terms_and_conditions" element={<TermsAndConditions />} />
              <Route path="/qpadm_runs/:id" element={<RunShowPage />} />
            </Routes>
          </Container>
          <Footer />
        </div>
      </UserProvider>
    </Router>
  );
}

export default App;
